import crmService from '../../services/crmService'

export default {
  state: {
    token: localStorage.getItem('token') || null,
    userData: {},
    roles: {},
    rolesForRegister: [],
  },
  mutations: {
    SET_TOKEN(state, token) {
      state.token = token
    },
    REMOVE_TOKEN(state) {
      state.token = null
    },
    SET_USER_DATA(state, userData) {
      state.userData = {
        ...userData,
        isAnon: !userData.isAnon,
      }
    },
    UPDATE_USER_DATA(state, userData) {
      state.userData.name = userData.name
      state.userData.surname = userData.surname
      state.userData.email = userData.email
      state.userData.phone = userData.phone
      state.userData.isAnon = userData.isAnon
    },
    SET_ROLES(state, roles) {
      state.roles = roles
    },
    SET_ROLES_FOR_REGISTER(state, roles) {
      state.rolesForRegister = roles
    },
    DELETE_ROLE(state, roleName) {
      const index = state.roles.indexOf(
        state.roles.find(role => role.roleName === roleName)
      )
      state.roles.splice(index)
    },
    ADD_ROLE(state, role) {
      state.roles.push(role)
    },
  },
  actions: {
    async login({ commit }, credentials) {
      const { data } = await crmService.login(credentials)
      commit('SET_TOKEN', data)
      localStorage.setItem('token', data)
    },
    logout({ commit }) {
      return crmService
        .logout()
        .then(() => {
          commit('REMOVE_TOKEN')
          localStorage.removeItem('token')
        })
        .catch(() => {
          commit('REMOVE_TOKEN')
          localStorage.removeItem('token')
        })
    },
    addUser(ctx, payload) {
      return crmService.register(payload)
    },
    async getUserData({ commit }) {
      const { data } = await crmService.getUserData()
      commit('SET_USER_DATA', data)
    },
    async updateUserData({ commit, state }, payload) {
      await crmService.updateUserData(
        {
          ...payload,
          isAnon: !payload.isAnon,
        },
        state.userData.id
      )
      commit('UPDATE_USER_DATA', payload)
    },
    async fetchRoles({ commit }) {
      const { data } = await crmService.fetchRoles()
      commit('SET_ROLES', data)
    },
    async fetchRolesForRegister({ commit }) {
      const { data } = await crmService.fetchRolesForRegister()
      commit('SET_ROLES_FOR_REGISTER', data)
    },
    updateRole({ getters }, payload) {
      let perms = getters.rolesAll.find(role => role.roleName === payload)
        .permlist
      let permList = []
      Object.entries(perms).forEach(perm => {
        if (perm[1]) permList.push(perm[0])
      })
      return crmService.updateRole(permList, payload)
    },
    deleteRole({ commit }, payload) {
      return crmService.deleteRole(payload).then(() => {
        commit('DELETE_ROLE', payload)
      })
    },
    addRole({ commit }, payload) {
      return crmService.addRole(payload).then(() => {
        commit('ADD_ROLE', {
          ...payload,
          permlist: {
            rodoPerm: payload.permlist.includes('rodoPerm'),
            usersPermission: payload.permlist.includes('usersPermission'),
            canGetListOfLeads: payload.permlist.includes('canGetListOfLeads'),
            userStatus: payload.permlist.includes('userStatus'),
            canCreateRole: payload.permlist.includes('canCreateRole'),
            changeProject: payload.permlist.includes('changeProject'),
            changeRole: payload.permlist.includes('changeRole'),
          },
        })
      })
    },
    changeUserRole(ctx, payload) {
      return crmService.changeUserRole(payload.userId, payload.roleName)
    },
    changePassword(context, payload) {
      return crmService.changePassword(payload)
    },
  },
  getters: {
    token: state => state.token,
    loggedIn: state => !!state.token,
    userData: state => state.userData,
    rolesForRegister: state => state.rolesForRegister,
    userRole: (state, getters) =>
      state.roles.find(item => item.id === getters.userData.role),
    rolesAll: state => state.roles,
    userPermissions: (state, getters) => getters.userRole.permlist,
    userRoleName: (state, getters) => getters.userRole.roleName,
    canAnonymize: (state, getters) => getters.userPermissions.rodoPerm,
    canGetListOfUsers: (state, getters) =>
      getters.userPermissions.usersPermission,
    canCreateRole: (state, getters) => getters.userPermissions.canCreateRole,
    canGetListOfLeads: (state, getters) =>
      getters.userPermissions.canGetListOfLeads,
    canChangeUserStatus: (state, getters) => getters.userPermissions.userStatus,
    canChangePdfTemplate: (state, getters) =>
      getters.userPermissions.changeProject,
    canCreateAdmin: (state, getters) => getters.userPermissions.changeRole,
  },
}
